import { Link } from "react-router-dom";
import iconWhite from "../assets/png/iconWhite.png";
import AppDownloadBadges from "../component/AppDownloadBadges";
import SiteLinksNav from "../component/SiteLinksNav";

import { FaTwitter, FaFacebookF, FaInstagram, FaGithub } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="w-full ">
      <div className=" mx-3 xs:mx-4 lg:mx-14  py-10 md:py-14 text-[#FFFFFF] ">
        {/* Top: Headline + CTA */}
        {/* <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <h3 className="text-2xl md:text-3xl font-semibold ">
            <span> Subscribe our Newsletter</span>
            <br className="hidden md:block" />
            <span>for</span><span className="text-sky-300"> Latest Updates</span>
          </h3>

          <button
            type="button"
            className="w-[250px] inline-flex items-center justify-center rounded-full border border-[#FFFFFF] bg-[#02476D] hover:bg-sky-800 px-5 py-2.5 text-base font-bold shadow-sm transition"
          >
            Subscribe Newsletter
          </button>
        </div> */}

        {/* Divider */}
        {/* <hr className="my-6 md:my-8 border-sky-700/60" /> */}

        <div className="flex flex-col xl:flex-row w-full gap-10 xl:gap-12 xl:items-start xl:justify-between">
          <div className="max-w-md shrink-0">
            <div className="flex items-center gap-3">
              <div>
                <img src={iconWhite} alt="Tydii" className="w-[100px] mb-2" />
              </div>
            </div>
            <h4 className="mt-5 mb-2 font-bold">About TYDII</h4>
            <div className="text-sm leading-6">
              Tydii is a laundry pickup and delivery platform built for modern
              living. From wash and fold to dry cleaning and tailoring, we help
              you book trusted local garment care services with convenience,
              transparency, and doorstep support.
            </div>
            <Link
              to="/support"
              className="font-[400] text-sm inline-block mt-2 hover:text-sky-200 transition"
            >
              Help@tydii.io
            </Link>

            <div className="flex items-center gap-4 mt-6">
              <Social href="#" label="Twitter">
                <FaTwitter />
              </Social>
              <Social href="#" label="Facebook">
                <FaFacebookF />
              </Social>
              <Social href="#" label="Instagram">
                <FaInstagram />
              </Social>
            </div>
          </div>

          <div className="flex flex-wrap gap-10 sm:gap-16 xl:gap-20">
            <List
              title="Company"
              links={[
                { label: "How It Works", to: "/marketing" },
                { label: "Laundry Business Partners", to: "/laundry-business" },
                { label: "Delivery Partners", to: "/delivery-partner" },
                { label: "Help & Support", to: "/support" },
              ]}
            />
            <List
              title="Help"
              links={[
                { label: "Help Center", to: "/support" },
                { label: "Customer Support", to: "/support" },
                { label: "Pickup & Delivery", to: "/delivery-partner" },
                { label: "Terms of Service", to: "/privacy-policy" },
                { label: "Privacy Policy", to: "/privacy-policy" },
                { label: "Delete Account", to: "/delete-account" },
              ]}
            />
          </div>

          <div className="flex flex-col items-start xl:items-end xl:text-right xl:ml-auto shrink-0">
            <h5 className="font-bold mb-3 text-sm">Download the app</h5>
            <p className="text-xs text-sky-100/90 mb-3">Customer app</p>
            <AppDownloadBadges
              appType="customer"
              theme="light"
              className="xl:justify-end"
            />
            <p className="text-xs text-sky-100/90 mt-5 mb-3">Driver app</p>
            <AppDownloadBadges
              appType="driver"
              theme="light"
              className="xl:justify-end"
            />
          </div>
        </div>

        <SiteLinksNav variant="dark" className="mt-10" />
      </div>

      {/* Bottom bar */}
      <div className="bg-sky-950/40 py-3 text-center text-xs md:text-sm text-sky-200">
        Powered by TYDII. © Copyrights 2025. All rights reserved.
      </div>
    </footer>
  );
}

function List({ title, items, links }) {
  const entries = links
    ? links.map(({ label, to }) => ({
        key: label,
        content: to ? (
          <Link to={to} className="hover:text-sky-200 transition">
            {label}
          </Link>
        ) : (
          label
        ),
      }))
    : (items || []).map((it) => ({ key: it, content: it }));
  return (
    <div className="text-[#FFFFFF]">
      <h5 className="font-bold mb-4 ">{title}</h5>
      <ul className="space-y-3 text-sm font-[400]">
        {entries.map(({ key, content }) => (
          <li key={key}>{content}</li>
        ))}
      </ul>
    </div>
  );
}

function Social({ href, label, children }) {
  return (
    <a
      href={href}
      aria-label={label}
      className="h-9 w-9 rounded-full grid place-items-center bg-sky-800 hover:bg-sky-700 ring-1 ring-sky-700/70 transition"
    >
      <span className="text-sky-100">{children}</span>
    </a>
  );
}
